import * as React from 'react'

type Props = {
  width?: string
  height?: string
  color?: string
  className?: string
}

const Plus = ({ height, width, color, className }: Props) => {
  const style = color
    ? {
        color,
      }
    : undefined

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      width={width}
      height={height}
      className={className}
    >
      <path
        fill="#121212"
        fillRule="evenodd"
        d="M19 11h-6V5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2Z"
        clipRule="evenodd"
      />
      <mask
        id="a"
        width="16"
        height="16"
        x="4"
        y="4"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M19 11h-6V5a1 1 0 1 0-2 0v6H5a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2Z"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#a)">
        <path fill="#121212" d="M0 0h24v24H0z" />
      </g>
    </svg>
  )
}

export default Plus
